import { render, staticRenderFns } from "./InputFile.vue?vue&type=template&id=5eb8aa08&"
import script from "./InputFile.js?vue&type=script&lang=js&"
export * from "./InputFile.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports